exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerType5 .text{margin-top:20px;margin-bottom:10px;font-weight:700;font-size:18px;line-height:20px;color:#98a1b3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType5/style.module.scss
// module id = 4887
// module chunks = 0